import React from "react";
import { Box } from "@chakra-ui/react";
import { Section } from "components/section";
import { TextTitle, type TextTitleProps } from "ui/text";
import { BookDemoButton } from "components/event-tracking";

type AiAgentsHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

const sharedProps: Pick<
  TextTitleProps,
  "align" | "mobileAlign" | "size" | "titleAs" | "descriptionAs" | "descriptionMaxW" | "actions"
> = {
  align: "center",
  mobileAlign: "center",
  size: "lg",
  titleAs: "h1",
  descriptionAs: "h2",
  descriptionMaxW: "700px",
  actions: <BookDemoButton useAgentsRouter />,
};

function HeroSection({ children }: { children: React.ReactNode }) {
  return (
    <Section
      center
      themeBgColor="white"
      my={0}
      pt={{ base: "48px", md: "sectionSpacingY.md" }}
      pb={{ base: "big", lg: "huger" }}
      pos="relative"
    >
      {children}
    </Section>
  );
}

export function AgentsHero({ eyebrow, title, description }: AiAgentsHeroProps) {
  return (
    <HeroSection>
      <Box pos="relative" zIndex={2}>
        <Box display={{ base: "none", lg: "block" }}>
          <TextTitle {...sharedProps} chip={{ text: eyebrow }} title={title} description={description} />
        </Box>
      </Box>
    </HeroSection>
  );
}

export function AgentsHeroMobile({ eyebrow, title, description }: AiAgentsHeroProps) {
  return (
    <HeroSection>
      <TextTitle {...sharedProps} chip={{ text: eyebrow }} title={title} description={description} />
    </HeroSection>
  );
}
